<template>
  <div>
    <div class="inner-header">
      <nav class="navbar fixed-top animate__animated animate__slideInRight">
        <router-link :to="{ name: 'CpEngagement'}" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
        </router-link>
         <a href="javascript:void(0);" class="link-title">{{this.broker_name}}</a>
      </nav>
    </div>

    <div class="inner-page animate__animated animate__slideInRight">
        <div class="container-fluid">
          <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card p-3">
                        <h3 class="fs-18 fw-600">₹{{this.collection_count}}</h3>
                        <p class="mb-0 fs-14 fw-500 text-grey">Total Connect & Collect</p>
                    </div>
                </div>
          </div>
        </div>
        <b-tabs pills content-class="mt-3" justified>
            <b-tab  content-class="mb-4"
              v-for="(tab, index) in tabs"
              :key="index"
              :active="tab.label === $route.query.status"
              :title="tab.title"
              @click="get_cp_details(tab.label)"
            >
              <div class="tab-table">
                <b-table striped hover @row-selected="onRowSelected" selectable :items="engagements"></b-table>
                <span class="result-Text text-grey text-center fs-12 fw-400 bg-white">Showing {{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
              </div>
            </b-tab>
          </b-tabs>
        <paginate v-if="totalPages > 1" v-model="pageNo" :page-count="totalPages" :click-handler="goToPage" :prev-text="'Prev'" :next-text="'Next'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'">
        </paginate>
    </div>
</div>
</template>
<script>
import { paramsFromQuery } from "@/assets/scripts/utility.js";
import qs from "qs";
export default {
  name: 'CPDetails',
  data() {
    return {
      tabs: [{title: 'Earned', label: 'earned'},{title: 'Redeemed', label: 'redeemed'},{title: 'Expired', label: 'expired'}],
      engagements: [],
      broker_name: '',
      total: 0,
      perPage: 0,
      queryP: {},
      collection_count:'',
      defTObj: {}
    }
  },
  created () {
    this.get_cp_details(this.$route.query.status)
  },
  watch: {
    $route(to, from) {
      this.get_cp_details();
    },
  },
  computed: {
    totalPages() {
      if (this.total === 0 || this.perPage === 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.perPage);
      }
    },
    pageNo: {
      get() {
        let pageNo = this.$route.query.pageNo || 1;
        return parseInt(pageNo);
      },
      set() {
        true;
      },
    },
    pageStart() {
      if (this.total === 0) {
        return 0;
      }
      return Math.max(0, (this.pageNo - 1) * this.perPage + 1);
    },
    pageEnd() {
      if (this.total === 0) {
        return 0;
      }
      return Math.min(this.total, this.pageNo * this.perPage);
    },
  },
  methods: {
    goToPage(pageNo) {
      let newQ = {
        ...this.$route.query,
        pageNo
      };
      this.$router.replace({
        query: newQ
      });
    },
    onRowSelected(items) {
      this.$router.replace({ name: 'CpDetail', params: { id: items[0].ID }, query: {cp_id: this.$route.params.id, credit_date_from: this.$route.query.credit_date_from, credit_date_upto: this.$route.query.credit_date_upto, status: this.defTObj.label}})
    },
    get_cp_details(value) {
      paramsFromQuery(this.queryP, this.$route.query);
      this.queryP['id'] = this.$route.params.id;
      if (this.$route.query.credit_date_from) {
        this.queryP['credit_date_from'] = this.$route.query.credit_date_from;
        this.queryP['credit_date_upto'] = this.$route.query.credit_date_upto;
        this.queryP['is_advanced_search'] = true
      }
      if (value === 'earned') {
        this.queryP['earned'] = true;
      } if (value === 'redeemed') {
        this.queryP['redeemed'] = true;
      } if (value === 'expired') {
        this.queryP['expired'] = true;
      }
      this.defTObj.label = value
      this.$axios.get(`brokers/${this.queryP.id}/cp_engagement_report`, { params: this.queryP,
       paramsSerializer: (params) =>
          qs.stringify(params, {
            arrayFormat: "brackets"
          }), }).then((res) => {
      this.engagements = []
      if (res.data.engagements) {
        res.data.engagements.forEach(eng => {
          this.engagements.push({ID: eng.id, Date: eng.credit_date, Amount: '₹' + eng.amount, Comment: 'Read'})
        })
      }
      this.collection_count = res.data.collection_count
      this.broker_name = res.data.broker_name
      this.perPage = res.data.per_page;
      this.total = res.data.count;
      this.queryP = {}
      });
    },
  }
}
</script>
<style scoped>
    .inner-page{
        margin-top: 60px;
    }
    .selfie-image{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .selfie-toggle{
        padding-left: 0;
    }
    .selfie-image-background{
        background: url('~@/assets/no-avatar.svg') no-repeat 0px center  #fff;
        min-height: 100px;
        min-width: 100px;
    }
</style>